import React, { Component } from 'react'
import PerMånad from '../../Components/PerMånad'
import PerKvartal from '../../Components/PerKvartal'
import IntlMessages from 'util/IntlMessages';
export default class Revenue extends Component {
    render() {
        return (
            <div  className="text-center h-100 d-flex flex-column">
                <div>
                    <h2 style={{ paddingTop: '12px', marginBottom:'1rem', color: 'white', fontWeight: '500' }}><IntlMessages id="DashBoard.revenue"/></h2>
                </div>
                <div className="d-flex row justify-content-center manage-margin align-items-center" style={{color:'white', flex: 1 }}>
                    <div className="col-5">
                        <PerMånad Afid={this.props.Afid} Flags={this.props.Flags} Kontor={this.props.Kontor}/>
                    </div>
                    <div className="col-5">
                        <PerKvartal Afid={this.props.Afid} Flags={this.props.Flags} Kontor={this.props.Kontor}/>
                    </div>
                </div>
            </div>
        )
    }
}
